<button mat-flat-button color="primary m-2" (click)="backToTreatments()">
    <mat-icon>close</mat-icon>
    Select A Different Treatment</button>
<div class="home">
    
    <div class="treatments">
            <h4 class="treatment__name">The <strong>{{ selectedTreatment?.name }}</strong> team</h4>
            <div class="treatment__underline"></div>
            <div class="treatment__staff w-100">
                <div *ngFor="let member of staffList" class="treatment__staff--member">
                    <div (click)="selectStaff($event, member, selectedTreatment?.idx)">
                        <app-staff-member [selectedStaff]="member" [page]="'home'"></app-staff-member>
                    </div>
                    <!--
                <div class="staffdetails__bio" *ngIf="selectedStaff.bio">
                    <span>Biography</span>
                    {{ selectedStaff.bio ? selectedStaff.bio : "" }}
                </div>
            -->

                </div>
                <div *ngIf="staffList ? staffList.length > 1 : false" class="treatment__staff--member">
                    <div (click)="selectAllStaffForTreatment(selectedTreatment)">
                        <app-staff-member [selectedStaff]="{firstname: 'Any', lastname: 'Practioner', profReg: 'from the '+selectedTreatment?.name+' team'}" [page]="'home'"></app-staff-member>
                    </div>
                    <!--
                <div class="staffdetails__bio" *ngIf="selectedStaff.bio">
                    <span>Biography</span>
                    {{ selectedStaff.bio ? selectedStaff.bio : "" }}
                </div>
            -->
                </div>
            </div>
        </div>
    </div>


 
<!--
        <div *ngIf="selectedTreatment === treatment && !showFastTrack" class="accordion-content-any-prac" [@slideInOut]>
            <div class="treatment_types">Select Treatment</div>
            <div *ngFor="let type of selectedTreatment.treatments" class="treatment-types-any-prac" (click)="staffOrTreatment(selectedTreatment, type)">
              <ul>
                <li>Treatment: {{ type.name }}</li>
                <li>Duration: {{ type.defaultDuration }} minutes</li>
                <li>Price: £{{ type.defaultPrice }}</li>
              </ul>
            </div>
          </div>
      </div>
    </div>
  </div>

-->